module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('ui-title', {
    attrs: {
      "icon": "account_circle"
    }
  }, [_vm._v("About")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c3e372a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/About.vue
// module id = 280
// module chunks = 2